import { SetDefaultData, FetchDocumentTypeRequest, UpdateField, UpdateDocumentTypeRequest } from './../document-types.actions';
import { getUpdateDocumentTypeState } from '../document-types.selectors';
import Validator from '@shared/validatorjs/src/validator';
import { ActivatedRoute } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Component, OnInit } from '@angular/core';
import FormTrait from 'src/app/traits/form.trait';
import { Subscription } from 'rxjs';
import { Map } from 'immutable';

@Component({
  selector: 'app-update-document-type',
  templateUrl: './update-document-type.component.html',
  styleUrls: ['./update-document-type.component.css']
})
export class UpdateDocumentTypeComponent extends FormTrait implements OnInit {

  private state$: Subscription;
  public isLoading: boolean;
  public documentTypeId: number;

  constructor(public store: Store<any>, private route: ActivatedRoute) {
    super()
  }

  ngOnInit() {
    this.documentTypeId = parseInt(this.route.snapshot.paramMap.get("id"))
    this.store.dispatch<any>(new SetDefaultData('updateDocumentType'))
    this.state$ = this.store.pipe(select(getUpdateDocumentTypeState)).subscribe(state => {
      this.state = state;
      this.isLoading = state.get('isLoading')
    });

    this.store.dispatch<any>(new FetchDocumentTypeRequest(this.documentTypeId))
  }

  public handleFieldChange(e: any, name: null | string = null): void {

    this.store.dispatch(
      new UpdateField(name || e.target.name, name ? e : e.target.value, 'updateDocumentType.data')
    );

    this.store.dispatch(
      new UpdateField('validationErrors', this.state
        .get('validationErrors')
        .delete(name || e.target.name), 'updateDocumentType')
    );
  }

  validation() {
    const data = this.state.get('data');
    const rules = {
      name: "required",
      description: "required",
    };
    const validator = new Validator(
      data.toJS(),
      rules,
    );

    return validator;
  }

  public onSubmit(e: Event): void {

    e.preventDefault();

    const validation = this.validation();
    const payload = this.state.get('data').toJS();

    if (validation.passes()) {
      this.store.dispatch(new UpdateDocumentTypeRequest(this.documentTypeId, payload));
    } else {
      this.store.dispatch<any>(
        new UpdateField('validationErrors', validation.errors.errors, 'updateDocumentType')
      );
    }
  }

}
